import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Taxes",
    subheader:
      "Add individual tax rates or enable automatic tax calculation and collection from every checkout."
  }),
  rows: [
    {
      title: {
        value: "Add tax rates",
        tooltip: "Add one or more static tax rates to any payment link."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    },
    {
      title: {
        value: "Automatic taxes",
        tooltip:
          "Enable automatic calculation and collection of sales tax, VAT and GST within checkout."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: true
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
